import { render, staticRenderFns } from "./LanguageOtherSettingView.vue?vue&type=template&id=ba4bbbaa&scoped=true&"
import script from "./LanguageOtherSettingView.vue?vue&type=script&lang=js&"
export * from "./LanguageOtherSettingView.vue?vue&type=script&lang=js&"
import style0 from "./LanguageOtherSettingView.vue?vue&type=style&index=0&id=ba4bbbaa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4bbbaa",
  null
  
)

export default component.exports